import {
	computed,
	Ref,
	ref,
	watch,
} from '@vue/composition-api';
import { useOnEveryEntry } from '@front-app/hooks/useOnEntry';
import { trackEventBannerAction } from '@front-app/services/ActionApi/ActionApi';
import { BannerAction, BannerLocation, UserAction } from '@front-app/services/ActionApi/UserActionRequestModel';
import { EventsBannerStore } from '@front-app/store/singletons/Events';
import { AsyncImage } from '@front-app/store/modules/image';
import { get, MaybeRef } from '@vueuse/shared';

export interface EventBannerData {
	eventId: string;
	location: BannerLocation;
	disableTracking: boolean;
	groupId?: string;
}

export interface UseEventBanner {
	onClick: () => Promise<void>;
	banner: Ref<AsyncImage>;
	bannerWrapper: Ref<null | HTMLElement>;
}

export const useEventBanner = (props: MaybeRef<EventBannerData>): UseEventBanner => {
	const bannerWrapper = ref(null);
	const banner = computed(() => EventsBannerStore.get(get(props).eventId));
	const hasTrackedViewForCurrentEventId = ref(false);
	watch(() => get(props).eventId, (curr) => {
		if (curr) {
			hasTrackedViewForCurrentEventId.value = false;
		}
	});
	watch(() => get(props).location, (curr) => {
		if (curr) {
			hasTrackedViewForCurrentEventId.value = false;
		}
	});
	const trackBannerActionWithMetaData = async (action: BannerAction) => {
		if (get(props).disableTracking) {
			return;
		}
		await trackEventBannerAction(get(props).eventId, action, {
			pageUrl: window.location.href,
			location: get(props).location,
			groupId: get(props).groupId,
		});
	};
	useOnEveryEntry(bannerWrapper, () => {
		EventsBannerStore.fetch(get(props).eventId);
		if (!hasTrackedViewForCurrentEventId.value) {
			trackBannerActionWithMetaData(UserAction.BANNER_VIEW);
			hasTrackedViewForCurrentEventId.value = true;
		}
	});
	const onClick = async () => trackBannerActionWithMetaData(UserAction.BANNER_CLICK);
	return {
		onClick,
		banner,
		bannerWrapper,
	};
};
